import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { FluidOwaSource } from 'owa-fluid-validations';
import { CommandProps } from '@fluidx/office-fluid-types';
import {
    addMeetingNotesForOccurrence,
    removeMeetingNotesForOccurrence,
} from '../components/CollabSpace.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import {
    initCollabSpaceViewState,
    setIsNewDoc,
    resetCollabSpaceStore,
    setIsShared,
    setIsCollabAllowed,
    setIsCollabSpaceExplicitlyDisabled,
} from '../mutators/collabSpaceMutators';
import { isSeriesInstance } from 'owa-calendar-event-capabilities';
import { showErrorInfo } from '../utils/collabSpaceErrorCheck';
import createFluidCollabSpace from './collabSpaceFluidUtils';
import { logUsage } from 'owa-analytics';
import { isEventFromDifferentMailbox } from './isEventFromDifferentMailbox';
import { getViewStateById } from '../selectors/collabSpaceSelectors';

export function getCollabSpaceActionMenuItems(
    event: CalendarEvent,
    fluidOwaSource: FluidOwaSource,
    viewStateId: string
): CommandProps[] {
    const menuItems: CommandProps[] = [];
    if (fluidOwaSource !== FluidOwaSource.CalendarCompose) {
        return menuItems;
    }

    const viewState = getViewStateById(viewStateId);
    if (!viewState) {
        return null;
    }

    const addCollabSpaceForOccurence = () => {
        const seriesInstanceShareLink = viewState.seriesInstanceShareLink;
        resetCollabSpaceStore(viewStateId);
        setIsShared('false', viewStateId);

        if (seriesInstanceShareLink == null) {
            createFluidCollabSpace(event, FluidOwaSource.CalendarCompose, viewStateId);
        } else {
            initCollabSpaceViewState(
                seriesInstanceShareLink,
                viewState.collabAllowed,
                viewState.isShared,
                viewStateId
            );
        }
    };

    const removeCollabSpaceForOccurence = () => {
        const seriesMasterShareLink = viewState.seriesMasterShareLink;
        if (seriesMasterShareLink == null) {
            setIsCollabAllowed(false, viewStateId);
            setIsCollabSpaceExplicitlyDisabled(true, viewStateId);
            return;
        }
        const collabAllowed = viewState.collabAllowed;
        resetCollabSpaceStore(viewStateId);
        setIsShared('true', viewStateId);
        setIsNewDoc(false, viewStateId);
        initCollabSpaceViewState(
            viewState.seriesMasterShareLink,
            collabAllowed,
            viewState.isShared,
            viewStateId
        );
        logUsage('RemoveCollabSpaceForOccurence', undefined, { isCore: true });
    };

    if (showRecurrenceMenuItem(event, viewStateId)) {
        if (viewState.isShared === 'true') {
            menuItems.push({
                displayName: loc(addMeetingNotesForOccurrence),
                id: loc(addMeetingNotesForOccurrence),
                icon: ControlIcons.OneNoteLogo,
                execute: addCollabSpaceForOccurence,
            });
        } else {
            menuItems.push({
                displayName: loc(removeMeetingNotesForOccurrence),
                id: loc(removeMeetingNotesForOccurrence),
                icon: ControlIcons.OneNoteLogo,
                execute: removeCollabSpaceForOccurence,
            });
        }
    }

    return menuItems;
}

function showRecurrenceMenuItem(calendarEvent: CalendarEvent, viewStateId: string) {
    return (
        calendarEvent.IsOrganizer &&
        isSeriesInstance(calendarEvent) &&
        getViewStateById(viewStateId)?.isShared !== null &&
        !isEventFromDifferentMailbox(calendarEvent) &&
        !showErrorInfo(viewStateId)
    );
}
